
import React from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../../../redux/slices/themeSlice'; 

const { Option } = Select;

const ThemeDropdown = () => {
  const dispatch = useDispatch();


  const { theme, themes } = useSelector((state) => state.theme);

  
  const handleThemeChange = (selectedTheme) => {
    dispatch(setTheme(selectedTheme)); 
  };

  return (
    <Select
      value={theme} 
      onChange={handleThemeChange} 
      style={{ width: 150 }}
    >
        
      {themes.map((t) => (
        <Option key={t} value={t}>
          {t.charAt(0).toUpperCase() + t.slice(1)} 
        </Option>
      ))}
    </Select>
  );
};

export default ThemeDropdown;
